import { render, staticRenderFns } from "./PartnerCompany.vue?vue&type=template&id=76c712ee&scoped=true&"
import script from "./PartnerCompany.vue?vue&type=script&lang=js&"
export * from "./PartnerCompany.vue?vue&type=script&lang=js&"
import style0 from "./PartnerCompany.vue?vue&type=style&index=0&id=76c712ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c712ee",
  null
  
)

export default component.exports